var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.725 15.53c-.2 0-.4-.1-.5-.2l-5-5.004c-.3-.3-.3-.8 0-1.1.3-.301.8-.301 1.1 0l4.5 4.503 4.5-4.504c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.101l-5 5.004c-.4.1-.6.2-.7.2z",
    fill: "#C4C4C4"
  })));
}
export default SvgDropdown;